export const USERS_COLLECTION = "users";
export const APP_VERSIONS_COLLECTION = "appVersions";
export const COMPANIES_COLLECTION = "companies";
export const JOIN_REQUESTS_COLLECTION = "joinRequests";
